import { action } from 'typesafe-actions';

import ActionTypes from '../constants/colors';
import { Color } from 'lib/modelBuilder/entities/Color';

export const getColors = () => action(ActionTypes.COLORS_REQUEST);
export const getColorsSuccess = (colors: Color[]) =>
  action(ActionTypes.COLORS_SUCCESS, { colors });
export const getColorsFailure = (error: object) =>
  action(ActionTypes.COLORS_FAILURE, { error });
